<app-header (toggleSideBarForMe)="sideBarToggler()"></app-header>

<router-outlet></router-outlet>
<app-footer [style.background-color]="infinity ? '#212121' : null"></app-footer>
